// extracted by mini-css-extract-plugin
export default {"marcWrapper":"marcWrapper---SfvZE","marc":"marc---x1Acm"};